import { IUser } from '../user/user';

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IManagementUser extends IUser {}
